export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/arcgis.892a7b1.svg";